import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plane, ShieldCheck } from "lucide-react";
export default function SecureYourItinerary() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="6946" id="request-a-screening" className="dark bg-secondary text-white relative w-full py-24 md:py-32 overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/luxury_passport_background.png')] bg-cover bg-center bg-no-repeat opacity-20 blur-sm scale-105" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 z-0 bg-primary/10" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex justify-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <Card className="w-full max-w-2xl bg-white/10 backdrop-blur-xl border-white/20 shadow-2xl text-center">
          <CardHeader className="space-y-4 pb-2">
            <div className="mx-auto bg-white/20 p-3 rounded-full w-fit mb-2">
              <ShieldCheck className="w-8 h-8 text-white" />
            </div>
            <CardTitle className="text-3xl md:text-5xl font-sans font-bold tracking-tighter text-white">
              Don't Ignore the Signs
            </CardTitle>
            <CardDescription className="text-lg text-white/90 max-w-lg mx-auto">
              Are you or a loved one struggling with poor sleep? Take our quick self-assessment to identify common symptoms and take the first step toward a healthier life.
            </CardDescription>
          </CardHeader>
          
          <CardContent className="py-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-white text-sm font-semibold">
              <div className="flex flex-col items-center gap-2 p-3 rounded-lg bg-white/10 border border-white/10 backdrop-blur-sm">
                <span className="uppercase tracking-widest text-xs opacity-80">Symptom</span>
                <span>Morning Fatigue</span>
              </div>
              <div className="flex flex-col items-center gap-2 p-3 rounded-lg bg-white/10 border border-white/10 backdrop-blur-sm">
                <span className="uppercase tracking-widest text-xs opacity-80">Sign</span>
                <span>Loud Snoring</span>
              </div>
              <div className="flex flex-col items-center gap-2 p-3 rounded-lg bg-white/10 border border-white/10 backdrop-blur-sm">
                <span className="uppercase tracking-widest text-xs opacity-80">Risk</span>
                <span>Breath Pauses</span>
              </div>
            </div>
          </CardContent>

          <CardFooter className="flex justify-center pt-4 pb-8">
            <Button asChild size="lg" className="h-14 px-10 text-lg bg-white hover:bg-white/90 text-secondary font-bold shadow-2xl transition-all hover:scale-105 active:scale-95">
              <Link to="#">
                <Plane className="mr-2 h-5 w-5" />
                Schedule My Screening
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}